import { useState } from 'react';
import { Progress } from '../ui/progress.tsx';

const TermCard = ({ term, handleEditTerm }) => {
  const getValue = () => {
    const startDate = new Date(term.startDate).getTime();
    const endDate = new Date(term.endDate).getTime();
    const currentDate = new Date();

    const duration = endDate - startDate;
    const elapsed = currentDate.getTime() - startDate;

    const progress = (elapsed / duration) * 100;
    return Math.round(Math.min(Math.max(progress, 0), 100));
  };
  return (
    <div
      className="mb-2 cursor-pointer p-1 hover:bg-gray-100"
      onClick={() => handleEditTerm(term)}
    >
      <div className="flex justify-between items-center">
        <p>{term.name}</p>
        <p className="text-xs text-gray-600">{getValue()}% Completed</p>
      </div>
      <Progress value={getValue()} className="w-full" />
    </div>
  );
};

export default TermCard;
